document.addEventListener('DOMContentLoaded', function () {

    function setupCheckboxAndInput(checkboxId, inputId, inputClassToCheck) {
        const inputElements = document.getElementsByClassName(inputClassToCheck);
        if (inputElements.length > 0) {
            const checkboxElement = document.getElementById(checkboxId);
            const inputElement = document.getElementById(inputId);

            checkboxElement.addEventListener('change', function () {
                inputElement.value = '';
            });

            inputElement.addEventListener('keyup', function () {
                if (this.value.length) {
                    checkboxElement.checked = false;
                }
            });
        }
    }

    setupCheckboxAndInput('pasDePrenom2', 'prenom2', 'form_prenom2_to_check');
});
